import { ApiClient } from "lib/utils/client/apiClient";

export const usersWidgetsDetails = async () => {
    return ApiClient('/customer-user/admin/counts',
        {
            method: 'GET',
        });
}

export const userslisting = async (data :{status:string,search?:string,page:number,limit:number}) => {
   return ApiClient('/customer-user/admin/status',
      {
         method: 'POST',
         body: JSON.stringify(data)
      }
   )
};

export const userDetailById = async (id: string) => {
   return ApiClient(`/customer-user/${id}`,
      {
         method: 'GET',
      }
   )
};

export const userImageUpload = async (id: string, data: FormData) => {
   return ApiClient(`/customer-user/admin/upload/${id}`,
      {
         method: 'PATCH',
         body: data
      }
   )
};

export const updateUserDetails = async(id:string,data:{first_name?:string, last_name?:string, email?:string, phone_no?:string, street_address?:string, Account_status?:string}) => {
   return ApiClient(`/customer-user/update/${id}`,
      {
         method: 'PATCH',
         body: JSON.stringify(data)
      }
   )
};